import { render } from "./Adminpanel.vue?vue&type=template&id=70123722&scoped=true"
import script from "./Adminpanel.vue?vue&type=script&lang=ts"
export * from "./Adminpanel.vue?vue&type=script&lang=ts"

import "./Adminpanel.vue?vue&type=style&index=0&id=70123722&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-70123722"

export default script